import Alpine from "alpinejs";

import { embedYtScript } from "../modules/video/youtube";
import { vjsPlayer } from "../modules/video/videojs";
import { damPlayer } from "../modules/video/dam";
import { vimeoPlayer } from "../modules/video/vimeo";

Alpine.magic("embedYtScript", () => (player, config = { autoplay: false }) => {    
    return embedYtScript(player, config);
});


Alpine.magic("vjsPlayer", () => (video, config = { autplay: false }) => {     
    if(config.autoplay) {
        video.play();        
    }
    return vjsPlayer(video);
});

Alpine.magic("damPlayer", () => (video) => {
    return damPlayer(video);
});


Alpine.magic("vimeoPlayer", () => (ops) => {
    return vimeoPlayer(ops);
});